import type { AccountsConfig } from './type';

export const accounts: AccountsConfig = {
    accountNameMinimumLength: 1,
    isJuniorAliasChangeAllowed: true,
    isNativeAliasChangeAllowed: true,
    accountDetailCopyActionAvailableForType: ['CURRENT', 'SAVING', 'LOAN'],
};
